import { useTranslation } from 'react-i18next';

import { errorCodes } from '@/modules/common/types/constants';

import { useMessage } from './context/message';

const useBackendErrorMessage = () => {
  const { setErrorMessage } = useMessage();
  const { i18n } = useTranslation();
  return (code: string | undefined, fallbackMessage: string) => {
    const message =
      code && Object.prototype.hasOwnProperty.call(errorCodes, code)
        ? // @ts-ignore
          errorCodes[code][i18n.language]
        : fallbackMessage;

    setErrorMessage(message);
  };
};

export default useBackendErrorMessage;
